<script>
import { handlers } from 'svelte/legacy';

import {
    projectState
} from '@app/store/projectStore.svelte.js';
import {
    explorerState
} from '@app/store/explorerStore.svelte.js';
import {
    showModal
} from '@app/store/modalStore.svelte.js';
import {
    environment
} from '@app/store/envStore.svelte.js';

/* Components */
import Exit from "./items/Exit.svelte";
import Logout from "./items/Logout.svelte";
import OnlineSave from "./items/OnlineSave.svelte";
import OfflineSave from "./items/OfflineSave.svelte";
import * as m from "@app/paraglide/messages.js";

/* Animation */
import { slide } from 'svelte/transition';
import { quintOut } from 'svelte/easing';

/** @type {{currentState: boolean, toggleMenu: (menu: string) => void}} */
let { currentState, toggleMenu } = $props();

let newMenu = $state(false),
    viewMenu = $state(false);

function handleToggleMenu() {
    toggleMenu('file');
}

function toggleNewMenu() {
    newMenu = !newMenu;
    handleToggleMenu();
}

function toggleViewMenu() {
    viewMenu = !viewMenu;
    handleToggleMenu();
}

function openProjectModal() {
    explorerState.context = "load";
    showModal("storageExplorer");
    handleToggleMenu();
}

function openRecentProjects() {
    explorerState.context = "load";
    showModal("recentProjects");
    handleToggleMenu();
}

function openModal(modalName) {
    showModal(modalName);
    handleToggleMenu();
}

function toggleFullscreen() {
    if (document.fullscreenElement) {
        document.exitFullscreen();
    } else {
        document.documentElement.requestFullscreen();
    }
}
</script>

<li class="nav-item dropdown {currentState ? 'show' : ''}" role="menuitem">
    <a onclick={handleToggleMenu} 
       class="dropdown-toggle nav-link" 
       href="#!/"
       id="fileMenuButton"
       aria-haspopup="true"
       aria-expanded={currentState}
       role="button"
       aria-label={m.file_menu()}>{m.file()}</a>
    <div class="dropdown-menu {currentState ? 'show' : ''}" 
         role="menu" 
         aria-labelledby="fileMenuButton">
        <a aria-label={m.new_menu()} 
           onclick={toggleNewMenu} 
           class="dropdown-item dropdown-toggle" 
           href="#!/"
           id="newSubMenu"
           aria-expanded={newMenu}
           aria-haspopup="true"
           role="menuitem">{m.new()}</a>
        {#if newMenu}
        <div transition:slide={{duration: 300, easing: quintOut }}>
        <a  class="dropdown-item bg-secondary bg-opacity-50" href="#!/" onclick={handlers(handleToggleMenu, () => showModal("newProject"))}>{m.project_ellipsis()}</a>
        <a class="dropdown-item bg-secondary bg-opacity-50" href="#!/" onclick={() => openModal("newEventGroup")}>{m.event_group_ellipsis()}</a>
        </div>
        {/if}
        
        {#if environment.online}
            <a class="dropdown-item" href="#!/" onclick={openProjectModal}>{m.open_project()}</a>
            <a class="dropdown-item" href="#!/" onclick={openRecentProjects}>{m.open_recent()}</a>
        {:else}
            <a class="dropdown-item" href="#!/" onclick={() => openModal("projectImport")}>{m.open_project()}</a>
        {/if}

        <hr class="dropdown-divider">
        {#if !environment.online || projectState.useLocalStorage}
        <OfflineSave></OfflineSave>
        {:else}
        <OnlineSave></OnlineSave>
        {/if}       
        <hr class="dropdown-divider">
        <a class="dropdown-item" href="#!/" onclick={() => openModal("fileImport")}>{m.import_ellipsis()}</a>
        <a class="dropdown-item" href="#!/" onclick={() => openModal("fileExport")}>{m.export_ellipsis()}</a>
        <a class="dropdown-item" href="#!/" onclick={() => openModal("batchSubtitleExport")}>{m.batch_export()}</a>
        {#if environment.electron}
            <hr class="dropdown-divider">
            <a onclick={toggleViewMenu} class="dropdown-item dropdown-toggle" href="#!/">{m.view()}</a>
            {#if viewMenu}
            <div transition:slide={{duration: 300, easing: quintOut }}>
                <a onclick={() => openModal("zoom")} class="dropdown-item bg-secondary bg-opacity-50" href="#!/">{m.zoom()}</a>
                <a onclick={toggleFullscreen} class="dropdown-item bg-secondary bg-opacity-50" href="#!/"><i class="bi bi-fullscreen me-1"></i> {m.full_screen()}</a>
            </div>
            {/if}
        {/if}
        <hr class="dropdown-divider">
        <Logout></Logout>
        {#if environment.electron}
            <Exit></Exit>                   
        {/if}
        
    </div>
</li>

<style lang="css">
.bg-secondary:hover {
    background-color: #0fbc8c !important;
}
</style>
